"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("sanitize.css");
require("../css/global.scss");
require("./Component/Navigation");
require("./Component/InterviewW");
require("./Component/ErpDocumentRequest");
const MVBanner_1 = __importDefault(require("./Component/MVBanner"));
const PageTop_1 = __importDefault(require("./Component/PageTop"));
const MainVisual_1 = __importDefault(require("./Component/MainVisual"));
const InlineLink_1 = __importDefault(require("./Component/InlineLink"));
const IntroductionMedia_1 = __importDefault(require("./Component/IntroductionMedia"));
class App {
    constructor() {
        this.funcs = [];
        this.exec = () => {
            while (this.funcs.length > 0) {
                const func = this.funcs.shift();
                func ? func() : null;
            }
        };
    }
    addEvent(func) {
        this.funcs.push(func);
    }
}
const app = new App;
app.addEvent(PageTop_1.default);
app.addEvent(MainVisual_1.default);
app.addEvent(MVBanner_1.default);
app.addEvent(InlineLink_1.default);
app.addEvent(IntroductionMedia_1.default);
// app.addEvent(Pjax);
window.addEventListener('DOMContentLoaded', app.exec, false);
